import logo from 'src/styles/image/maintenance-icon.png';

const Maintenance = () => {
  return (
    <div className="bg-[#e7e7e6] h-screen">
      <div className="flex justify-center items-center h-screen">
        <div className="flex flex-col">
          <div className="flex justify-center text-2xl ">メンテナンス中</div>
          <br />
          <img width={400} src={logo} alt="メンテナンス中" />
        </div>
      </div>
    </div>
  );
};

export default Maintenance;
